import angular from 'angular';

import SigninPage from '../../pages/signin';
import StatusRow from '../../directives/status-message/status-row';

import SigninModalConf from './signin.config';

export default angular.module('modals.sign-in', [SigninPage, StatusRow])
	.run(['$templateCache', ($templateCache) => {
		$templateCache.put('/signin/signin.fields.html', require('../../pages/signin/signin.fields.html'));
	}])
	.constant('SigninModalConf', SigninModalConf)
	.name;



// WEBPACK FOOTER //
// ./project/modals/signin/index.js